

































































import { Component, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';

@Component({
  data: () => ({
    rules: {
      senderAddrLimit: (value: string) => (value && (value.length === 46 || value.length === 40)) || '送金先アドレス(-除く)は40文字です。',
      senderAddrInput: (value: string) => {
        const pattern = /^[a-zA-Z0-9-]+$/;
        return pattern.test(value) || '送金先の入力が不正です';
      },
      amountLimit: (value: number) => (value >= 0) || '数量を入力してください',
      amountInput: (value: string) => {
        const pattern = /^[0-9.]+$/;
        return (pattern.test(value) && !isNaN(Number(value))) || '数量の入力が不正です';
      },
      messageRules: (value: string) => (value.length <= 1024) || 'メッセージの最大文字数が超えています。',
    },
  }),
  computed: {
      ...mapGetters({ address: 'wallet/address', balance: 'wallet/balance', successMessage: 'wallet/message', errorMessage: 'wallet/error' }),
  },
})
export default class Wallet extends Vue {
    private isLoading: boolean = false;
    private toAmount: number = 0;
    private toAddress: string = '';
    private toMessage: string = '';
    private validation: any[] = [];

    private async created() {
        await this.$store.dispatch('wallet/loadOrCreateWallet');
        this.getBalance();
    }

    private async getBalance() {
        this.isLoading = true;
        await this.$store.dispatch('wallet/getBalance', this.$store.state.wallet.address);
        this.isLoading = false;
    }

    private tapSend() {
        if (this.isValidation() === true) {
            const payload = {
                toAddress: this.toAddress,
                toAmount: this.toAmount,
                toMessage: this.toMessage,
                privateKey: this.$store.state.wallet.privateKey,
            };
            this.$store.dispatch('wallet/sendXem', payload);
        }
    }

    private isValidation() {
        this.validation = [];
        this.validation.push(this.$data.rules.senderAddrLimit(this.toAddress));
        this.validation.push(this.$data.rules.senderAddrInput(this.toAddress));
        this.validation.push(this.$data.rules.amountLimit(this.toAmount));
        this.validation.push(this.$data.rules.amountInput(this.toAmount));
        this.validation.push(this.$data.rules.messageRules(this.toMessage));
        let isError: boolean = false;
        this.validation.forEach((obj: any) => {
            if (obj !== true) { isError = true; }
        });
        return !isError;
    }
}
